import { grammarFor } from "@shared/utils/grammar.utils";
import { ProductListingItem } from "./abProducts.types";

export const getProductListingCountLabel = (items: readonly ProductListingItem[]): string => {
  const first = items[0];
  if (!first) return "prodotti";

  const noun = grammarFor(first.product);
  if (!items.every(({ product }) => grammarFor(product).lemma === noun.lemma)) return "prodotti";

  return items.length === 1 ? noun.lemma : noun.plural;
};
